import { render, staticRenderFns } from "./sponsors.vue?vue&type=template&id=c94bf9e2&"
import script from "./sponsors.vue?vue&type=script&lang=js&"
export * from "./sponsors.vue?vue&type=script&lang=js&"
import style0 from "./sponsors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sponsors.vue"
export default component.exports